<template>
	<form id="edit-user-form" novalidate class="needs-validation" :class="{'was-validated':hasError}" v-on:submit.prevent="saveForm">

		<error :error="error"></error>

		<div class="form-row">
			<div class="col-sm-6">
				<div class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="user-first-name">First Name</label>
					<input id="user-first-name" class="form-control" placeholder="" v-model="firstNameValue"/>
				</div>
			</div>
			<div class="col-sm-6">
				<div class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="user-last-name">Last Name</label>
					<input id="user-last-name" class="form-control" placeholder="" v-model="lastNameValue"/>				</div>
			</div>
		</div>

		<div class="form-row">
			<div class="col-sm-6">
				<div class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="role-select">Role</label>
					<select id="role-select" class="form-control custom-select" v-model="roleValue">
						<option value="ReadOnly">Read Only</option>
						<option value="User">User</option>
						<option value="SiteAdmin">Site Admin</option>
						<option value="GlobalAdmin">Global Admin</option>
					</select>
				</div>
			</div>
			<div class="col-sm-6">
				<div class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="show-password-select">Show Password</label>
					<select id="show-password-select" class="form-control custom-select" v-model="showPasswordValue" :disabled="!isInRole('GlobalAdmin')">
						<option value="false">No</option>
						<option value="true">Yes</option>
					</select>
				</div>
			</div>
		</div>
	
		<div class="clearfix mt-1 mb-3">
			<div class="float-left ml-3">
				
			</div>
			<div class="float-right mr-3">
				<button type="submit" class="btn btn-outline-primary px-3">Update</button>
				<button type="button" class="btn btn-outline-primary px-3" @click="closeForm">Cancel</button>
			</div>
		</div>

	</form>
</template>

<script>
	import Error from './Error'

	import api from '../api'
	import store from '../state'
	import router from '../router'

	export default {
		name: 'EditUserForm',
		components: {Error},
		props: ['user'],
		data() {
			return {
				error: '',
				roleValue:'',
				firstNameValue: this.user.firstName,
				lastNameValue: this.user.lastName,
				showPasswordValue: this.user.showPasswords
			}
		},
		methods: {
			closeForm() {
				this.$emit('close-edit-user');
			},
			async saveForm() {
				
				try
				{
					const updatedUser = {
						site: this.user.site,
						email: this.user.email,
						firstName: this.firstNameValue,
						lastName: this.lastNameValue,
						showPasswords: this.showPasswordValue,
						roles:[]
					};

					//Set roles
					const possibleRoles = ["ReadOnly", "User", "SiteAdmin", "GlobalAdmin"];
					
					for (let role of possibleRoles) {
						updatedUser.roles.push(role);
						if (this.roleValue == role) break;
					}

					//Remove the readonly role if has other roles
					if (updatedUser.roles.length > 1) updatedUser.roles.shift();

					const response = await api.put('system/user', updatedUser);	

					//Copy these values back onto the user object
					this.user.firstName = this.firstNameValue;
					this.user.lastName = this.lastNameValue;
					this.user.showPasswords = this.showPasswordValue;
					this.user.roles = updatedUser.roles;

					this.closeForm();
				}
				catch(err) {
					this.error = err + ""; //Get the string representation of the error		
				}
			},
			isInRole(role) {
				if (!store.state.user || !store.state.user.roles) return false;
				return store.state.user.roles.indexOf(role) > -1;
			}
		},
		computed: {
			hasError() {
				return false;
			}
		},
		mounted() {
			this.roleValue = this.user.roles[this.user.roles.length -1];
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/EditUserForm.vue